
  
// This file is auto-generated on 'generateEnumTypings.ts'. Do not edit it manually.
export interface DictionaryObject<T> {
  name: string;
  identifier: T;
}

export enum FeatureCategory {
  FACILITIES = 'facilities',
  DIFFERENTIALS = 'differentials',
  EXTERNAL_AREA = 'external_area',
  ROOMS = 'rooms',
}

export const featureCategoriesTranslations: Record<FeatureCategory, string> = {
  [FeatureCategory.FACILITIES]: 'Facilidades',
  [FeatureCategory.DIFFERENTIALS]: 'Diferenciais',
  [FeatureCategory.EXTERNAL_AREA]: 'Área externa',
  [FeatureCategory.ROOMS]: 'Cômodos',
}

export interface FeatureCategoryObject extends DictionaryObject<FeatureCategory> { }

export const featureCategories: FeatureCategoryObject[] = [
  { name: 'Facilidades', identifier: FeatureCategory.FACILITIES },
  { name: 'Diferenciais', identifier: FeatureCategory.DIFFERENTIALS },
  { name: 'Área externa', identifier: FeatureCategory.EXTERNAL_AREA },
  { name: 'Cômodos', identifier: FeatureCategory.ROOMS },
];

export enum PropertyTypeEnum {
  APARTMENT = 'apartment',
  COMMERCIAL = 'commercial',
  COMMERCIAL_BUILDING = 'commercial_building',
  COMMERCIAL_POINT = 'commercial_point',
  COMMERCIAL_SET = 'commercial_set',
  CONDO_HOUSE = 'condo_house',
  CONDO_LAND = 'condo_land',
  DUPLEX = 'duplex',
  FLAT = 'flat',
  GARDEN = 'garden',
  HOUSE = 'house',
  INDUSTRIAL_WAREHOUSE = 'industrial_warehouse',
  LAND = 'land',
  LOFT = 'loft',
  PENTHOUSE = 'penthouse',
  STUDIO = 'studio',
  TRIPLEX = 'triplex',
  VILLAGE_HOUSE = 'village_house',
}

export interface PropertyTypeObject extends DictionaryObject<PropertyTypeEnum> { }

export const propertyTypes: PropertyTypeObject[] = [
  { name: 'Apartamento', identifier: PropertyTypeEnum.APARTMENT },
  { name: 'Comercial', identifier: PropertyTypeEnum.COMMERCIAL },
  { name: 'Prédio', identifier: PropertyTypeEnum.COMMERCIAL_BUILDING },
  { name: 'Ponto Comercial', identifier: PropertyTypeEnum.COMMERCIAL_POINT },
  { name: 'Conjunto Comercial', identifier: PropertyTypeEnum.COMMERCIAL_SET },
  { name: 'Casa de condomínio', identifier: PropertyTypeEnum.CONDO_HOUSE },
  { name: 'Terreno em condomínio', identifier: PropertyTypeEnum.CONDO_LAND },
  { name: 'Duplex', identifier: PropertyTypeEnum.DUPLEX },
  { name: 'Flat', identifier: PropertyTypeEnum.FLAT },
  { name: 'Garden', identifier: PropertyTypeEnum.GARDEN },
  { name: 'Casa', identifier: PropertyTypeEnum.HOUSE },
  { name: 'Galpão Industrial', identifier: PropertyTypeEnum.INDUSTRIAL_WAREHOUSE },
  { name: 'Terreno', identifier: PropertyTypeEnum.LAND },
  { name: 'Loft', identifier: PropertyTypeEnum.LOFT },
  { name: 'Cobertura', identifier: PropertyTypeEnum.PENTHOUSE },
  { name: 'Studio', identifier: PropertyTypeEnum.STUDIO },
  { name: 'Triplex', identifier: PropertyTypeEnum.TRIPLEX },
  { name: 'Casa de vila', identifier: PropertyTypeEnum.VILLAGE_HOUSE },
];

export const propertyTypesTranslations: Record<PropertyTypeEnum, string> = {
  [PropertyTypeEnum.APARTMENT]: 'Apartamento',
  [PropertyTypeEnum.COMMERCIAL]: 'Comercial',
  [PropertyTypeEnum.COMMERCIAL_BUILDING]: 'Prédio',
  [PropertyTypeEnum.COMMERCIAL_POINT]: 'Ponto Comercial',
  [PropertyTypeEnum.COMMERCIAL_SET]: 'Conjunto Comercial',
  [PropertyTypeEnum.CONDO_HOUSE]: 'Casa de condomínio',
  [PropertyTypeEnum.CONDO_LAND]: 'Terreno em condomínio',
  [PropertyTypeEnum.DUPLEX]: 'Duplex',
  [PropertyTypeEnum.FLAT]: 'Flat',
  [PropertyTypeEnum.GARDEN]: 'Garden',
  [PropertyTypeEnum.HOUSE]: 'Casa',
  [PropertyTypeEnum.INDUSTRIAL_WAREHOUSE]: 'Galpão Industrial',
  [PropertyTypeEnum.LAND]: 'Terreno',
  [PropertyTypeEnum.LOFT]: 'Loft',
  [PropertyTypeEnum.PENTHOUSE]: 'Cobertura',
  [PropertyTypeEnum.STUDIO]: 'Studio',
  [PropertyTypeEnum.TRIPLEX]: 'Triplex',
  [PropertyTypeEnum.VILLAGE_HOUSE]: 'Casa de vila',
}
  
export enum PropertyTypeSlug {
  APARTMENT = 'apartamento',
  COMMERCIAL = 'comercial',
  COMMERCIAL_BUILDING = 'predio',
  COMMERCIAL_POINT = 'ponto-comercial',
  COMMERCIAL_SET = 'conjunto-comercial',
  CONDO_HOUSE = 'casa-de-condominio',
  CONDO_LAND = 'terreno-em-condominio',
  DUPLEX = 'duplex',
  FLAT = 'flat',
  GARDEN = 'garden',
  HOUSE = 'casa',
  INDUSTRIAL_WAREHOUSE = 'galpao-industrial',
  LAND = 'terreno',
  LOFT = 'loft',
  PENTHOUSE = 'cobertura',
  STUDIO = 'studio',
  TRIPLEX = 'triplex',
  VILLAGE_HOUSE = 'casa-de-vila',
}

export const PropertyTypePlurals: Record<PropertyTypeEnum, string> = {
  [PropertyTypeEnum.APARTMENT]: 'Apartamentos',
  [PropertyTypeEnum.COMMERCIAL]: 'Comerciais',
  [PropertyTypeEnum.COMMERCIAL_BUILDING]: 'Prédio',
  [PropertyTypeEnum.COMMERCIAL_POINT]: 'Ponto Comercial',
  [PropertyTypeEnum.COMMERCIAL_SET]: 'Conjunto Comercial',
  [PropertyTypeEnum.CONDO_HOUSE]: 'Casas de condomínio',
  [PropertyTypeEnum.CONDO_LAND]: 'Terrenos em condomínio',
  [PropertyTypeEnum.DUPLEX]: 'Duplexes',
  [PropertyTypeEnum.FLAT]: 'Flats',
  [PropertyTypeEnum.GARDEN]: 'Gardens',
  [PropertyTypeEnum.HOUSE]: 'Casas',
  [PropertyTypeEnum.INDUSTRIAL_WAREHOUSE]: 'Galpão Industrial',
  [PropertyTypeEnum.LAND]: 'Terrenos',
  [PropertyTypeEnum.LOFT]: 'Lofts',
  [PropertyTypeEnum.PENTHOUSE]: 'Coberturas',
  [PropertyTypeEnum.STUDIO]: 'Studios',
  [PropertyTypeEnum.TRIPLEX]: 'Triplexes',
  [PropertyTypeEnum.VILLAGE_HOUSE]: 'Casas de vila',
}

export const propertyTypesSlugByValue: Record<PropertyTypeEnum, PropertyTypeSlug> = {
  [PropertyTypeEnum.APARTMENT]: PropertyTypeSlug.APARTMENT,
  [PropertyTypeEnum.COMMERCIAL]: PropertyTypeSlug.COMMERCIAL,
  [PropertyTypeEnum.COMMERCIAL_BUILDING]: PropertyTypeSlug.COMMERCIAL_BUILDING,
  [PropertyTypeEnum.COMMERCIAL_POINT]: PropertyTypeSlug.COMMERCIAL_POINT,
  [PropertyTypeEnum.COMMERCIAL_SET]: PropertyTypeSlug.COMMERCIAL_SET,
  [PropertyTypeEnum.CONDO_HOUSE]: PropertyTypeSlug.CONDO_HOUSE,
  [PropertyTypeEnum.CONDO_LAND]: PropertyTypeSlug.CONDO_LAND,
  [PropertyTypeEnum.DUPLEX]: PropertyTypeSlug.DUPLEX,
  [PropertyTypeEnum.FLAT]: PropertyTypeSlug.FLAT,
  [PropertyTypeEnum.GARDEN]: PropertyTypeSlug.GARDEN,
  [PropertyTypeEnum.HOUSE]: PropertyTypeSlug.HOUSE,
  [PropertyTypeEnum.INDUSTRIAL_WAREHOUSE]: PropertyTypeSlug.INDUSTRIAL_WAREHOUSE,
  [PropertyTypeEnum.LAND]: PropertyTypeSlug.LAND,
  [PropertyTypeEnum.LOFT]: PropertyTypeSlug.LOFT,
  [PropertyTypeEnum.PENTHOUSE]: PropertyTypeSlug.PENTHOUSE,
  [PropertyTypeEnum.STUDIO]: PropertyTypeSlug.STUDIO,
  [PropertyTypeEnum.TRIPLEX]: PropertyTypeSlug.TRIPLEX,
  [PropertyTypeEnum.VILLAGE_HOUSE]: PropertyTypeSlug.VILLAGE_HOUSE,
}

export const propertyTypesValueBySlug: Record<PropertyTypeSlug, PropertyTypeEnum> = {
  [PropertyTypeSlug.APARTMENT]: PropertyTypeEnum.APARTMENT,
  [PropertyTypeSlug.COMMERCIAL]: PropertyTypeEnum.COMMERCIAL,
  [PropertyTypeSlug.COMMERCIAL_BUILDING]: PropertyTypeEnum.COMMERCIAL_BUILDING,
  [PropertyTypeSlug.COMMERCIAL_POINT]: PropertyTypeEnum.COMMERCIAL_POINT,
  [PropertyTypeSlug.COMMERCIAL_SET]: PropertyTypeEnum.COMMERCIAL_SET,
  [PropertyTypeSlug.CONDO_HOUSE]: PropertyTypeEnum.CONDO_HOUSE,
  [PropertyTypeSlug.CONDO_LAND]: PropertyTypeEnum.CONDO_LAND,
  [PropertyTypeSlug.DUPLEX]: PropertyTypeEnum.DUPLEX,
  [PropertyTypeSlug.FLAT]: PropertyTypeEnum.FLAT,
  [PropertyTypeSlug.GARDEN]: PropertyTypeEnum.GARDEN,
  [PropertyTypeSlug.HOUSE]: PropertyTypeEnum.HOUSE,
  [PropertyTypeSlug.INDUSTRIAL_WAREHOUSE]: PropertyTypeEnum.INDUSTRIAL_WAREHOUSE,
  [PropertyTypeSlug.LAND]: PropertyTypeEnum.LAND,
  [PropertyTypeSlug.LOFT]: PropertyTypeEnum.LOFT,
  [PropertyTypeSlug.PENTHOUSE]: PropertyTypeEnum.PENTHOUSE,
  [PropertyTypeSlug.STUDIO]: PropertyTypeEnum.STUDIO,
  [PropertyTypeSlug.TRIPLEX]: PropertyTypeEnum.TRIPLEX,
  [PropertyTypeSlug.VILLAGE_HOUSE]: PropertyTypeEnum.VILLAGE_HOUSE,
}

export const propertyTypeSlugTranslations: Record<PropertyTypeSlug, string> = {
  apartamento: 'Apartamento',
  comercial: 'Comercial',
  predio: 'Prédio',
  'ponto-comercial': 'Ponto Comercial',
  'conjunto-comercial': 'Conjunto Comercial',
  'casa-de-condominio': 'Casa de condomínio',
  'terreno-em-condominio': 'Terreno em condomínio',
  duplex: 'Duplex',
  flat: 'Flat',
  garden: 'Garden',
  casa: 'Casa',
  'galpao-industrial': 'Galpão Industrial',
  terreno: 'Terreno',
  loft: 'Loft',
  cobertura: 'Cobertura',
  studio: 'Studio',
  triplex: 'Triplex',
  'casa-de-vila': 'Casa de vila',
}

export enum FeatureEnum {
  ACCESSIBILITY = 'accessibility',
  AIR_CONDITIONING = 'air_conditioning',
  ALL_TIME_FRONTDESK = 'all_time_frontdesk',
  AUTHOR_ARCHITECTURE = 'author_architecture',
  BANQUET_HALL = 'banquet_hall',
  BARBECUE_GRILL = 'barbecue_grill',
  BATHTUB = 'bathtub',
  BIKE_PARKING = 'bike_parking',
  CLOSET = 'closet',
  COWORKING = 'coworking',
  DAYTIME_FRONTDESK = 'daytime_frontdesk',
  DEED_PARKING_SPOT = 'deed_parking_spot',
  DELIVERY_ELEVATOR = 'delivery_elevator',
  ELECTRIC_CAR_PARKING_SPOT = 'electric_car_parking_spot',
  ELECTRIC_HEATING = 'electric_heating',
  ELECTRONIC_FRONTDESK = 'electronic_frontdesk',
  FIREPLACE = 'fireplace',
  FIXED_PARKING_SPOT = 'fixed_parking_spot',
  FOR_RENOVATION = 'for_renovation',
  FREE_PARKING_SPOT = 'free_parking_spot',
  FURNISHED = 'furnished',
  GAME_ROOM = 'game_room',
  GAS_HEATING = 'gas_heating',
  GENERATOR = 'generator',
  GOURMET_AREA = 'gourmet_area',
  GOURMET_TERRACE = 'gourmet_terrace',
  GREEN_SPACE = 'green_space',
  GYM = 'gym',
  HAS_LAVABO = 'has_lavabo',
  HEATED_POOL = 'heated_pool',
  HOME_OFFICE = 'home_office',
  KIDS_SPACE = 'kids_space',
  LAUNDRY = 'laundry',
  MEDIA_ROOM = 'media_room',
  NEAR_METRO = 'near_metro',
  NIGHTTIME_FRONTDESK = 'nighttime_frontdesk',
  ONE_PER_FLOOR = 'one_per_floor',
  PANTRY = 'pantry',
  PARKING_LOT = 'parking_lot',
  PETS = 'pets',
  PETS_ALLOWED = 'pets_allowed',
  PLAYGROUND = 'playground',
  POOL = 'pool',
  PRIVATE_HALL = 'private_hall',
  PRIVATE_POOL = 'private_pool',
  RENOVATED = 'renovated',
  SAUNA = 'sauna',
  SERVICE_AREA = 'service_area',
  SPA = 'spa',
  SPORTS_COURT = 'sports_court',
  TENNIS_COURT = 'tennis_court',
  TERRACE = 'terrace',
  VALET_PARKING = 'valet_parking',
  WAREHOUSE = 'warehouse',
  WITHOUT_FRONTDESK = 'without_frontdesk',
  YARD = 'yard',
}

export interface FeatureObject extends DictionaryObject<FeatureEnum> {
  category: FeatureCategory;
}

export const featuresArray: FeatureObject[] = [
  { name: 'Acessibilidade', identifier: FeatureEnum.ACCESSIBILITY, category: FeatureCategory.FACILITIES },
  { name: 'Ar-condicionado', identifier: FeatureEnum.AIR_CONDITIONING, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Portaria 24hrs', identifier: FeatureEnum.ALL_TIME_FRONTDESK, category: FeatureCategory.FACILITIES },
  { name: 'Arquitetura de autor', identifier: FeatureEnum.AUTHOR_ARCHITECTURE, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Salão de festas', identifier: FeatureEnum.BANQUET_HALL, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Churrasqueira', identifier: FeatureEnum.BARBECUE_GRILL, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Banheira', identifier: FeatureEnum.BATHTUB, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Bicicletário', identifier: FeatureEnum.BIKE_PARKING, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Closet', identifier: FeatureEnum.CLOSET, category: FeatureCategory.ROOMS },
  { name: 'Coworking', identifier: FeatureEnum.COWORKING, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Portaria diurna', identifier: FeatureEnum.DAYTIME_FRONTDESK, category: FeatureCategory.FACILITIES },
  { name: 'Vaga escriturada', identifier: FeatureEnum.DEED_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  { name: 'Elevador de delivery', identifier: FeatureEnum.DELIVERY_ELEVATOR, category: FeatureCategory.FACILITIES },
  { name: 'Vaga carro elétrico', identifier: FeatureEnum.ELECTRIC_CAR_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  { name: 'Aquecimento elétrico', identifier: FeatureEnum.ELECTRIC_HEATING, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Portaria eletrônica', identifier: FeatureEnum.ELECTRONIC_FRONTDESK, category: FeatureCategory.FACILITIES },
  { name: 'Lareira', identifier: FeatureEnum.FIREPLACE, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Vaga demarcada', identifier: FeatureEnum.FIXED_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  { name: 'Para reformar', identifier: FeatureEnum.FOR_RENOVATION, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Vaga livre', identifier: FeatureEnum.FREE_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  { name: 'Mobiliado', identifier: FeatureEnum.FURNISHED, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Salão de jogos', identifier: FeatureEnum.GAME_ROOM, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Aquecimento à gás', identifier: FeatureEnum.GAS_HEATING, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Gerador', identifier: FeatureEnum.GENERATOR, category: FeatureCategory.FACILITIES },
  { name: 'Espaço gourmet', identifier: FeatureEnum.GOURMET_AREA, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Varanda gourmet', identifier: FeatureEnum.GOURMET_TERRACE, category: FeatureCategory.ROOMS },
  { name: 'Área verde', identifier: FeatureEnum.GREEN_SPACE, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Academia', identifier: FeatureEnum.GYM, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Lavabo', identifier: FeatureEnum.HAS_LAVABO, category: FeatureCategory.ROOMS },
  { name: 'Piscina aquecida', identifier: FeatureEnum.HEATED_POOL, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Home office', identifier: FeatureEnum.HOME_OFFICE, category: FeatureCategory.ROOMS },
  { name: 'Brinquedoteca', identifier: FeatureEnum.KIDS_SPACE, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Lavanderia', identifier: FeatureEnum.LAUNDRY, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Cinema', identifier: FeatureEnum.MEDIA_ROOM, category: FeatureCategory.ROOMS },
  { name: 'Próximo ao metrô', identifier: FeatureEnum.NEAR_METRO, category: FeatureCategory.FACILITIES },
  { name: 'Portaria noturna', identifier: FeatureEnum.NIGHTTIME_FRONTDESK, category: FeatureCategory.FACILITIES },
  { name: 'Um por andar', identifier: FeatureEnum.ONE_PER_FLOOR, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Despensa', identifier: FeatureEnum.PANTRY, category: FeatureCategory.ROOMS },
  { name: 'Estacionamento', identifier: FeatureEnum.PARKING_LOT, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Pet place', identifier: FeatureEnum.PETS, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Permite animais', identifier: FeatureEnum.PETS_ALLOWED, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Playground', identifier: FeatureEnum.PLAYGROUND, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Piscina', identifier: FeatureEnum.POOL, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Hall privativo', identifier: FeatureEnum.PRIVATE_HALL, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Piscina privativa', identifier: FeatureEnum.PRIVATE_POOL, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Reformado', identifier: FeatureEnum.RENOVATED, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Sauna', identifier: FeatureEnum.SAUNA, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Área de serviço', identifier: FeatureEnum.SERVICE_AREA, category: FeatureCategory.ROOMS },
  { name: 'Spa', identifier: FeatureEnum.SPA, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Quadra esportiva', identifier: FeatureEnum.SPORTS_COURT, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Quadra de tênis', identifier: FeatureEnum.TENNIS_COURT, category: FeatureCategory.EXTERNAL_AREA },
  { name: 'Varanda', identifier: FeatureEnum.TERRACE, category: FeatureCategory.ROOMS },
  { name: 'Manobrista', identifier: FeatureEnum.VALET_PARKING, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Depósito privativo', identifier: FeatureEnum.WAREHOUSE, category: FeatureCategory.DIFFERENTIALS },
  { name: 'Sem portaria', identifier: FeatureEnum.WITHOUT_FRONTDESK, category: FeatureCategory.FACILITIES },
  { name: 'Quintal', identifier: FeatureEnum.YARD, category: FeatureCategory.EXTERNAL_AREA },
];

export const features: Record<FeatureEnum, FeatureObject> = {
  [FeatureEnum.ACCESSIBILITY]: { name: 'Acessibilidade', identifier: FeatureEnum.ACCESSIBILITY, category: FeatureCategory.FACILITIES },
  [FeatureEnum.AIR_CONDITIONING]: { name: 'Ar-condicionado', identifier: FeatureEnum.AIR_CONDITIONING, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.ALL_TIME_FRONTDESK]: { name: 'Portaria 24hrs', identifier: FeatureEnum.ALL_TIME_FRONTDESK, category: FeatureCategory.FACILITIES },
  [FeatureEnum.AUTHOR_ARCHITECTURE]: { name: 'Arquitetura de autor', identifier: FeatureEnum.AUTHOR_ARCHITECTURE, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.BANQUET_HALL]: { name: 'Salão de festas', identifier: FeatureEnum.BANQUET_HALL, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.BARBECUE_GRILL]: { name: 'Churrasqueira', identifier: FeatureEnum.BARBECUE_GRILL, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.BATHTUB]: { name: 'Banheira', identifier: FeatureEnum.BATHTUB, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.BIKE_PARKING]: { name: 'Bicicletário', identifier: FeatureEnum.BIKE_PARKING, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.CLOSET]: { name: 'Closet', identifier: FeatureEnum.CLOSET, category: FeatureCategory.ROOMS },
  [FeatureEnum.COWORKING]: { name: 'Coworking', identifier: FeatureEnum.COWORKING, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.DAYTIME_FRONTDESK]: { name: 'Portaria diurna', identifier: FeatureEnum.DAYTIME_FRONTDESK, category: FeatureCategory.FACILITIES },
  [FeatureEnum.DEED_PARKING_SPOT]: { name: 'Vaga escriturada', identifier: FeatureEnum.DEED_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  [FeatureEnum.DELIVERY_ELEVATOR]: { name: 'Elevador de delivery', identifier: FeatureEnum.DELIVERY_ELEVATOR, category: FeatureCategory.FACILITIES },
  [FeatureEnum.ELECTRIC_CAR_PARKING_SPOT]: { name: 'Vaga carro elétrico', identifier: FeatureEnum.ELECTRIC_CAR_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  [FeatureEnum.ELECTRIC_HEATING]: { name: 'Aquecimento elétrico', identifier: FeatureEnum.ELECTRIC_HEATING, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.ELECTRONIC_FRONTDESK]: { name: 'Portaria eletrônica', identifier: FeatureEnum.ELECTRONIC_FRONTDESK, category: FeatureCategory.FACILITIES },
  [FeatureEnum.FIREPLACE]: { name: 'Lareira', identifier: FeatureEnum.FIREPLACE, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.FIXED_PARKING_SPOT]: { name: 'Vaga demarcada', identifier: FeatureEnum.FIXED_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  [FeatureEnum.FOR_RENOVATION]: { name: 'Para reformar', identifier: FeatureEnum.FOR_RENOVATION, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.FREE_PARKING_SPOT]: { name: 'Vaga livre', identifier: FeatureEnum.FREE_PARKING_SPOT, category: FeatureCategory.FACILITIES },
  [FeatureEnum.FURNISHED]: { name: 'Mobiliado', identifier: FeatureEnum.FURNISHED, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.GAME_ROOM]: { name: 'Salão de jogos', identifier: FeatureEnum.GAME_ROOM, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.GAS_HEATING]: { name: 'Aquecimento à gás', identifier: FeatureEnum.GAS_HEATING, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.GENERATOR]: { name: 'Gerador', identifier: FeatureEnum.GENERATOR, category: FeatureCategory.FACILITIES },
  [FeatureEnum.GOURMET_AREA]: { name: 'Espaço gourmet', identifier: FeatureEnum.GOURMET_AREA, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.GOURMET_TERRACE]: { name: 'Varanda gourmet', identifier: FeatureEnum.GOURMET_TERRACE, category: FeatureCategory.ROOMS },
  [FeatureEnum.GREEN_SPACE]: { name: 'Área verde', identifier: FeatureEnum.GREEN_SPACE, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.GYM]: { name: 'Academia', identifier: FeatureEnum.GYM, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.HAS_LAVABO]: { name: 'Lavabo', identifier: FeatureEnum.HAS_LAVABO, category: FeatureCategory.ROOMS },
  [FeatureEnum.HEATED_POOL]: { name: 'Piscina aquecida', identifier: FeatureEnum.HEATED_POOL, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.HOME_OFFICE]: { name: 'Home office', identifier: FeatureEnum.HOME_OFFICE, category: FeatureCategory.ROOMS },
  [FeatureEnum.KIDS_SPACE]: { name: 'Brinquedoteca', identifier: FeatureEnum.KIDS_SPACE, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.LAUNDRY]: { name: 'Lavanderia', identifier: FeatureEnum.LAUNDRY, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.MEDIA_ROOM]: { name: 'Cinema', identifier: FeatureEnum.MEDIA_ROOM, category: FeatureCategory.ROOMS },
  [FeatureEnum.NEAR_METRO]: { name: 'Próximo ao metrô', identifier: FeatureEnum.NEAR_METRO, category: FeatureCategory.FACILITIES },
  [FeatureEnum.NIGHTTIME_FRONTDESK]: { name: 'Portaria noturna', identifier: FeatureEnum.NIGHTTIME_FRONTDESK, category: FeatureCategory.FACILITIES },
  [FeatureEnum.ONE_PER_FLOOR]: { name: 'Um por andar', identifier: FeatureEnum.ONE_PER_FLOOR, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.PANTRY]: { name: 'Despensa', identifier: FeatureEnum.PANTRY, category: FeatureCategory.ROOMS },
  [FeatureEnum.PARKING_LOT]: { name: 'Estacionamento', identifier: FeatureEnum.PARKING_LOT, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.PETS]: { name: 'Pet place', identifier: FeatureEnum.PETS, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.PETS_ALLOWED]: { name: 'Permite animais', identifier: FeatureEnum.PETS_ALLOWED, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.PLAYGROUND]: { name: 'Playground', identifier: FeatureEnum.PLAYGROUND, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.POOL]: { name: 'Piscina', identifier: FeatureEnum.POOL, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.PRIVATE_HALL]: { name: 'Hall privativo', identifier: FeatureEnum.PRIVATE_HALL, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.PRIVATE_POOL]: { name: 'Piscina privativa', identifier: FeatureEnum.PRIVATE_POOL, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.RENOVATED]: { name: 'Reformado', identifier: FeatureEnum.RENOVATED, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.SAUNA]: { name: 'Sauna', identifier: FeatureEnum.SAUNA, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.SERVICE_AREA]: { name: 'Área de serviço', identifier: FeatureEnum.SERVICE_AREA, category: FeatureCategory.ROOMS },
  [FeatureEnum.SPA]: { name: 'Spa', identifier: FeatureEnum.SPA, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.SPORTS_COURT]: { name: 'Quadra esportiva', identifier: FeatureEnum.SPORTS_COURT, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.TENNIS_COURT]: { name: 'Quadra de tênis', identifier: FeatureEnum.TENNIS_COURT, category: FeatureCategory.EXTERNAL_AREA },
  [FeatureEnum.TERRACE]: { name: 'Varanda', identifier: FeatureEnum.TERRACE, category: FeatureCategory.ROOMS },
  [FeatureEnum.VALET_PARKING]: { name: 'Manobrista', identifier: FeatureEnum.VALET_PARKING, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.WAREHOUSE]: { name: 'Depósito privativo', identifier: FeatureEnum.WAREHOUSE, category: FeatureCategory.DIFFERENTIALS },
  [FeatureEnum.WITHOUT_FRONTDESK]: { name: 'Sem portaria', identifier: FeatureEnum.WITHOUT_FRONTDESK, category: FeatureCategory.FACILITIES },
  [FeatureEnum.YARD]: { name: 'Quintal', identifier: FeatureEnum.YARD, category: FeatureCategory.EXTERNAL_AREA },
};

export const featuresTranslations: Record<FeatureEnum, string> = {
  [FeatureEnum.ACCESSIBILITY]: 'Acessibilidade',
  [FeatureEnum.AIR_CONDITIONING]: 'Ar-condicionado',
  [FeatureEnum.ALL_TIME_FRONTDESK]: 'Portaria 24hrs',
  [FeatureEnum.AUTHOR_ARCHITECTURE]: 'Arquitetura de autor',
  [FeatureEnum.BANQUET_HALL]: 'Salão de festas',
  [FeatureEnum.BARBECUE_GRILL]: 'Churrasqueira',
  [FeatureEnum.BATHTUB]: 'Banheira',
  [FeatureEnum.BIKE_PARKING]: 'Bicicletário',
  [FeatureEnum.CLOSET]: 'Closet',
  [FeatureEnum.COWORKING]: 'Coworking',
  [FeatureEnum.DAYTIME_FRONTDESK]: 'Portaria diurna',
  [FeatureEnum.DEED_PARKING_SPOT]: 'Vaga escriturada',
  [FeatureEnum.DELIVERY_ELEVATOR]: 'Elevador de delivery',
  [FeatureEnum.ELECTRIC_CAR_PARKING_SPOT]: 'Vaga carro elétrico',
  [FeatureEnum.ELECTRIC_HEATING]: 'Aquecimento elétrico',
  [FeatureEnum.ELECTRONIC_FRONTDESK]: 'Portaria eletrônica',
  [FeatureEnum.FIREPLACE]: 'Lareira',
  [FeatureEnum.FIXED_PARKING_SPOT]: 'Vaga demarcada',
  [FeatureEnum.FOR_RENOVATION]: 'Para reformar',
  [FeatureEnum.FREE_PARKING_SPOT]: 'Vaga livre',
  [FeatureEnum.FURNISHED]: 'Mobiliado',
  [FeatureEnum.GAME_ROOM]: 'Salão de jogos',
  [FeatureEnum.GAS_HEATING]: 'Aquecimento à gás',
  [FeatureEnum.GENERATOR]: 'Gerador',
  [FeatureEnum.GOURMET_AREA]: 'Espaço gourmet',
  [FeatureEnum.GOURMET_TERRACE]: 'Varanda gourmet',
  [FeatureEnum.GREEN_SPACE]: 'Área verde',
  [FeatureEnum.GYM]: 'Academia',
  [FeatureEnum.HAS_LAVABO]: 'Lavabo',
  [FeatureEnum.HEATED_POOL]: 'Piscina aquecida',
  [FeatureEnum.HOME_OFFICE]: 'Home office',
  [FeatureEnum.KIDS_SPACE]: 'Brinquedoteca',
  [FeatureEnum.LAUNDRY]: 'Lavanderia',
  [FeatureEnum.MEDIA_ROOM]: 'Cinema',
  [FeatureEnum.NEAR_METRO]: 'Próximo ao metrô',
  [FeatureEnum.NIGHTTIME_FRONTDESK]: 'Portaria noturna',
  [FeatureEnum.ONE_PER_FLOOR]: 'Um por andar',
  [FeatureEnum.PANTRY]: 'Despensa',
  [FeatureEnum.PARKING_LOT]: 'Estacionamento',
  [FeatureEnum.PETS]: 'Pet place',
  [FeatureEnum.PETS_ALLOWED]: 'Permite animais',
  [FeatureEnum.PLAYGROUND]: 'Playground',
  [FeatureEnum.POOL]: 'Piscina',
  [FeatureEnum.PRIVATE_HALL]: 'Hall privativo',
  [FeatureEnum.PRIVATE_POOL]: 'Piscina privativa',
  [FeatureEnum.RENOVATED]: 'Reformado',
  [FeatureEnum.SAUNA]: 'Sauna',
  [FeatureEnum.SERVICE_AREA]: 'Área de serviço',
  [FeatureEnum.SPA]: 'Spa',
  [FeatureEnum.SPORTS_COURT]: 'Quadra esportiva',
  [FeatureEnum.TENNIS_COURT]: 'Quadra de tênis',
  [FeatureEnum.TERRACE]: 'Varanda',
  [FeatureEnum.VALET_PARKING]: 'Manobrista',
  [FeatureEnum.WAREHOUSE]: 'Depósito privativo',
  [FeatureEnum.WITHOUT_FRONTDESK]: 'Sem portaria',
  [FeatureEnum.YARD]: 'Quintal',
}

export const featuresByCategory: Record<FeatureCategory, FeatureEnum[]> = {
  [FeatureCategory.FACILITIES]: [FeatureEnum.ACCESSIBILITY, FeatureEnum.ALL_TIME_FRONTDESK, FeatureEnum.DAYTIME_FRONTDESK, FeatureEnum.DEED_PARKING_SPOT, FeatureEnum.DELIVERY_ELEVATOR, FeatureEnum.ELECTRIC_CAR_PARKING_SPOT, FeatureEnum.ELECTRONIC_FRONTDESK, FeatureEnum.FIXED_PARKING_SPOT, FeatureEnum.FREE_PARKING_SPOT, FeatureEnum.GENERATOR, FeatureEnum.NEAR_METRO, FeatureEnum.NIGHTTIME_FRONTDESK, FeatureEnum.WITHOUT_FRONTDESK],
  [FeatureCategory.DIFFERENTIALS]: [FeatureEnum.AIR_CONDITIONING, FeatureEnum.AUTHOR_ARCHITECTURE, FeatureEnum.BATHTUB, FeatureEnum.ELECTRIC_HEATING, FeatureEnum.FIREPLACE, FeatureEnum.FOR_RENOVATION, FeatureEnum.FURNISHED, FeatureEnum.GAS_HEATING, FeatureEnum.ONE_PER_FLOOR, FeatureEnum.PETS, FeatureEnum.PETS_ALLOWED, FeatureEnum.PRIVATE_HALL, FeatureEnum.PRIVATE_POOL, FeatureEnum.RENOVATED, FeatureEnum.VALET_PARKING, FeatureEnum.WAREHOUSE],
  [FeatureCategory.EXTERNAL_AREA]: [FeatureEnum.BANQUET_HALL, FeatureEnum.BARBECUE_GRILL, FeatureEnum.BIKE_PARKING, FeatureEnum.COWORKING, FeatureEnum.GAME_ROOM, FeatureEnum.GOURMET_AREA, FeatureEnum.GREEN_SPACE, FeatureEnum.GYM, FeatureEnum.HEATED_POOL, FeatureEnum.KIDS_SPACE, FeatureEnum.LAUNDRY, FeatureEnum.PARKING_LOT, FeatureEnum.PLAYGROUND, FeatureEnum.POOL, FeatureEnum.SAUNA, FeatureEnum.SPA, FeatureEnum.SPORTS_COURT, FeatureEnum.TENNIS_COURT, FeatureEnum.YARD],
  [FeatureCategory.ROOMS]: [FeatureEnum.CLOSET, FeatureEnum.GOURMET_TERRACE, FeatureEnum.HAS_LAVABO, FeatureEnum.HOME_OFFICE, FeatureEnum.MEDIA_ROOM, FeatureEnum.PANTRY, FeatureEnum.SERVICE_AREA, FeatureEnum.TERRACE],
};
  